__turbopack_context__.v({
  "premiumBadge": "OrganizerNameWithBadge-module-scss-module__sjarmq__premiumBadge",
  "premiumNameEnd": "OrganizerNameWithBadge-module-scss-module__sjarmq__premiumNameEnd",
  "premiumTooltip": "OrganizerNameWithBadge-module-scss-module__sjarmq__premiumTooltip",
});
